import { useMedia } from 'react-use';
import { Flex, GridContent, Heading, Paragraph, ThemeConstellation } from '@zillow/constellation';
import type { TourConfirmationType } from '@zg-rentals/ts-z-calendar-client';

import { StyledToggleCard } from './StyledComponents';
import TourConfirmationTypeCard from '../../../TourConfirmationTypeCard';
import { TOUR_CONFIRMATION_TYPE_LAYOUT, TOUR_OPTIONS } from '../../../../constants/TourCalendar';

const { breakpoints } = ThemeConstellation.ns();

type TourCalendarConfigProps = {
  onTourTypeSelection: (tourType: TourConfirmationType) => void;
  tourConfirmationType?: TourConfirmationType;
  titleTag?: keyof JSX.IntrinsicElements;
  tourTitleTag?: keyof JSX.IntrinsicElements;
};

const TourCalendarConfig = ({
  onTourTypeSelection,
  tourConfirmationType,
  titleTag,
  tourTitleTag,
}: TourCalendarConfigProps) => {
  const isScreenMobile = useMedia(`(max-width: ${breakpoints.md}px)`);

  return (
    <>
      <GridContent
        gridColumnStart={{ default: '2', md: '4' }}
        gridColumnEnd={{ default: 'span 22', md: 'span 10' }}
        marginTop={{ md: 'xs' }}
        padding={0}
        data-testid="TourCalendarConfig-Body"
      >
        <Heading level="4" as={titleTag ?? 'h4'} fontFamily="serif" marginBottom="xs">
          Select the tour booking method that works best for you
        </Heading>
        <Paragraph fontColor="textMedium" marginBottom={{ default: 'md', md: 5 }}>
          After a tour&apos;s scheduled, we&apos;ll send reminders so no one misses the tour. You can update your
          booking method at any time.
        </Paragraph>
      </GridContent>
      <GridContent
        gridColumnStart={{ default: '2', md: '4' }}
        gridColumnEnd={{ default: 'span 22', md: 'span 18' }}
        padding={0}
      >
        <Flex display="flex" flexDirection={{ default: 'column', md: 'row' }} gap={{ default: 'sm', md: 'md' }}>
          {TOUR_OPTIONS.map((tourOption, index) => (
            <StyledToggleCard
              key={index}
              cardType="secondary"
              pressed={tourOption.id === tourConfirmationType}
              onClick={() => onTourTypeSelection(tourOption.id)}
              data-testid={`TourCalendarConfig-TourType${index}`}
            >
              <TourConfirmationTypeCard
                layout={
                  isScreenMobile ? TOUR_CONFIRMATION_TYPE_LAYOUT.HORIZONTAL : TOUR_CONFIRMATION_TYPE_LAYOUT.VERTICAL
                }
                titleTag={titleTag}
                tourOption={tourOption}
                tourTitleTag={tourTitleTag}
              />
            </StyledToggleCard>
          ))}
        </Flex>
      </GridContent>
    </>
  );
};

export default TourCalendarConfig;
